import { Switch, SwitchProps } from 'antd';
import { genTestID } from '../../utils/utils';

interface TaggedSwitchOwnProps extends SwitchProps{
  tag:string
}

const TaggedSwitch = (props:TaggedSwitchOwnProps) => {
  const {
    tag,
  } = props;

  return (
    <Switch {...props} data-testid={genTestID('switch', tag)} />
  );
};

export default TaggedSwitch;
